import dni from './dni'
import modelNumeric from './model-numeric'
import zeroIfEmpty from './zero-if-empty'

export default {
  dni,
  modelNumeric,
  zeroIfEmpty
}
